import CloseIcon from '@mui/icons-material/Close'
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import { GridToolbarContainer, GridToolbarFilterButton } from '@mui/x-data-grid-pro'
import React from 'react'

import T from 'T'

import { TOOLBAR_PADDING_Y } from './notificationCenterConstants'

declare module '@mui/x-data-grid-pro' {
  interface NoRowsOverlayPropsOverrides {
    title: string
    description: string
  }

  interface ToolbarPropsOverrides {
    query: string
    setFilterButtonEl: (element: HTMLButtonElement | null) => void
    onQueryChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    onQueryClear: () => void
  }
}

type NotificationGridToolbarProps = {
  query: string
  setFilterButtonEl: (element: HTMLButtonElement | null) => void
  onQueryChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onQueryClear: () => void
}

/**
 * Search plus the grid's own filter button. It lives here rather than on the page
 * because the filter panel anchors to this button — with `columnHeaderHeight={0}`
 * there is no column header for it to fall back to.
 */
const NotificationGridToolbar = ({ query, setFilterButtonEl, onQueryChange, onQueryClear }: NotificationGridToolbarProps) => (
  <GridToolbarContainer sx={{ px: 0, py: TOOLBAR_PADDING_Y, gap: 1 }}>
    <Stack direction="row" spacing={1} sx={{ width: '100%', alignItems: 'center' }}>
      <TextField
        fullWidth
        placeholder={T.SEARCH_NOTIFICATIONS_PLACEHOLDER}
        size="small"
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon fontSize="small" />
              </InputAdornment>
            ),
            // Only once there is something to clear, so the field doesn't carry a dead control.
            endAdornment: query ? (
              <InputAdornment position="end">
                <IconButton aria-label={T.CLEAR} edge="end" size="small" onClick={onQueryClear}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          },
        }}
        value={query}
        onChange={onQueryChange}
      />
      <GridToolbarFilterButton ref={setFilterButtonEl} slotProps={{ button: { variant: 'outlined' } }} />
    </Stack>
  </GridToolbarContainer>
)

export default NotificationGridToolbar
